import React, { useRef, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";
import BrandingHeader from "../components/BrandingHeader";
import image from "../assets/images/mentors.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ForgotPassword() {
  const emailRef = useRef();
  const { resetPassword } = useAuth();
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setLoading(true);
      await resetPassword(emailRef.current.value);
      toast.success("Email sent! ✅ Check your email for further instructions");
    } catch {
      toast.error("Failed to Reset Password");
    }
    setLoading(false);
  }

  return (
    <div className="bg-white  h-screen">
      <BrandingHeader />
      <div className="w-full flex flex-wrap">
        <div className="w-full md:w-1/2 flex flex-col">
          <div className="flex flex-col justify-center md:justify-start my-auto pt-20 md:pt-auto px-8 md:px-24 lg:px-32">
            <p className="text-center font-semibold text-3xl">
              Account Recovery
            </p>
            <form
              className="flex flex-col pt-3 md:pt-8"
              onSubmit={handleSubmit}
            >
              <div className="flex flex-col pt-4">
                <label for="email" className="text-lg">
                  Email
                </label>
                <input
                  type="email"
                  ref={emailRef}
                  id="email"
                  placeholder="you@email.com"
                  className="
                  mt-1
                          block
                          w-full
                          px-5
                          py-2.5
                          text-base
                          placeholder-gray-300
                          transition
                          duration-500
                          ease-in-out
                          transform
                          border border-transparent
                          rounded-lg
                          text-neutral-600
                          bg-gray-100
                          focus:outline-none
                          focus:border-transparent
                          focus:ring-2
                          focus:ring-white
                          focus:ring-offset-2
                          focus:ring-offset-gray-300
                        "
                />
              </div>

              <button
                type="submit"
                class="
                flex
                mt-4
                items-center
                justify-center
                w-full
                px-10
                py-2.5
                text-base
                font-medium
                text-center text-white
                transition
                duration-500
                ease-in-out
                transform
                bg-gradient-to-r from-blue-500 to-blue-900
                rounded-lg
                hover:bg-blue-700
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-blue-500
              "
                disabled={loading}
              >
                Reset Password
              </button>
            </form>
            <div className="text-center pt-12 pb-12">
              <p>
                Don't have an account?{" "}
                <Link
                  to="/signup"
                  className="underline font-semibold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-900"
                >
                  Register here
                </Link>
              </p>
            </div>
          </div>
        </div>

        <div className="w-1/2">
          <img
            className="object-cover  w-full h-screen hidden md:block"
            alt="img"
            src={image}
          />
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default ForgotPassword;
